// const {modal} = require('/assets/plugins/bootstrap-5.1.3/dist/js/popper.min');
// const $ = require('jquery');

$( document ).ready( f => {

    document.addEventListener( 'keydown', function ( event ) {
        if ( $( '.fancybox__container' ).length > 0 ) {
            if ( event.key === "Escape" ) {
                event.preventDefault();
            }
        }
    });

    lazyload();

    var BuilderElements = {
        $window: null,
        _body_elem_list: null,
        _header: null,
        _header_type: null,
        _header_property: null,
        _header_menu_right: null,
        _jumbotron: null,
        _bookingBar: null,
        _header_logo: null,
        $modalBtn: null,
    };
    BuilderElements.$window = $( window );
    BuilderElements._body_elem_list = $( 'body > *' );
    BuilderElements._header = $( 'header' );
    BuilderElements._header_one = $( 'header.header-one' );
    BuilderElements._header_two = $( 'header.header-two' );
    BuilderElements._header_type = BuilderElements._header.attr( 'data-builder-header' );
    BuilderElements._header_property = BuilderElements._header.attr( 'data-builder-property' );
    BuilderElements._header_menu_right = $( '#header-side-menu' );
    BuilderElements._jumbotron = $( 'section.jumbotron' );
    BuilderElements._bookingBar = document.querySelector( 'section.booking-bar' );
    BuilderElements._header_logo = BuilderElements._header.find( 'a.navbar-brand > *' ) ? BuilderElements._header.find( 'a.navbar-brand > *' ) : null;
    BuilderElements.$modalBtn = $( '.modal-btn' );

    if ( BuilderElements._header_logo != null ) {
        for ( let i=0; i<BuilderElements._header_logo.length; i++ ) {
            $( BuilderElements._header_logo[i]).addClass( 'logo' );

            if ( $( BuilderElements._header_logo[i]).find( 'img.alt' ).length > 0 ) {
                $( BuilderElements._header_logo[i]).addClass( 'alt' );
            }
        }
    }
    if ( BuilderElements._header_type === 'different' ) {

        $.fn.headerOverflowCheck( BuilderElements._header );

    } else if ( BuilderElements._header_type === 'double' ) {

        $.fn.headerDoubleOverflowCheck( BuilderElements._header_one, BuilderElements._header_two );

    } else if ( BuilderElements._header_type === 'centered' ) {

        $.fn.headerCenteredOverflowCheck( BuilderElements._header );

    } else if ( BuilderElements._header_type === 'default' ) {

        $.fn.headerOverflowCheck( BuilderElements._header );

    }

    if ( BuilderElements._jumbotron != null ) {
        const _logoDecoration = BuilderElements._jumbotron.find( '.logo-decoration' );
        if ( _logoDecoration.length > 0 ) {
            _logoDecoration.parent().css( 'display', 'table-cell' );
        }
    }

    $( 'a' ).click( ( element ) => {
        if ( $( element.currentTarget ).attr( 'href' ) === '#' ) {
            element.preventDefault();
        }
    });

    $( '[data-fancybox]' ).each( ( i, element ) => {

        if ( $( element ).attr( 'data-fancybox' ).length === 0 ) {
            $( element ).removeAttr( 'data-fancybox' );
            $( element ).removeAttr( 'data-src' );
        }
    });
    $( '[data-bs-target]' ).each( ( i, element ) => {

        if ( $( element ).attr( 'data-bs-target' ).length === 0 ) {
            $( element ).removeAttr( 'data-bs-target' );
            $( element ).removeAttr( 'data-bs-toggle' );
        }
    });

    // -------------- /b elements to /strong for aChecker (NOT USED, might be usefull in future) --------------
    const root = document.querySelector( 'body' );
    const elems = root.getElementsByTagName( 'b' );

    if ( elems.length > 0 ) {
        $.fn.toArray( elems ).forEach( function ( elem ) {
            const newElem = document.createElement( 'strong' );
            newElem.textContent = elem.textContent;
            elem.parentNode.replaceChild( newElem, elem );
        });
    }
    // -------------- END /b elements to /strong for aChecker --------------
});

( function ( $ ) {
    $.fn.initElements = () => {
        const BuilderElements = {};

        BuilderElements.$window = $( window );
        BuilderElements._body_elem_list = $( 'body > *' );
        BuilderElements._header = $( 'header' );
        BuilderElements._header_type = BuilderElements._header.attr( 'data-builder-header' );
        BuilderElements._header_menu_right = $( '#header-side-menu' );
        BuilderElements._jumbotron = $( 'section.jumbotron' );
        BuilderElements._bookingBar = $( 'section.booking-bar' ) > 0 ? this.$( 'section.booking-bar' ) : null;
        BuilderElements._header_logo = BuilderElements._header.find( 'a.navbar-brand > *' ) ? BuilderElements._header.find( 'a.navbar-brand > *' ) : null;
        BuilderElements.$modalBtn = $( '.modal-btn' );

        return BuilderElements;
    }
    $.fn.scrollCheck = ( _header ) => {
        let fill = null;
        if ( _header.hasClass( 'navbar-design-color' ) ) {
            fill = 'navbar-design-color';
            _header.find( 'svg polygon' ).attr( 'fill', $( '.' + fill ).css( 'background-color' ) );
        } else if ( _header.hasClass( 'navbar-custom-color' ) ) {
            fill = 'navbar-custom-color';
            _header.find( 'svg polygon' ).attr( 'fill', $( '.' + fill ).css( 'background-color' ) );
        } else if ( _header.hasClass( 'navbar-dark' ) ) {
            fill = 'navbar-dark';
            _header.find( 'svg polygon' ).attr( 'fill', $( '.' + fill ).css( 'background-color' ) );
        } else if ( _header.hasClass( 'navbar-light' ) ) {
            fill = 'navbar-light';
            _header.find( 'svg polygon' ).attr( 'fill', $( '.' + fill ).css( 'background-color' ) );
        } else {
            _header.find( 'svg polygon' ).attr( 'fill', '#FFF' );
        }
    };

    $.fn.initSideMenuStyle = ( _header, _header_menu_right, header_type_two=false ) => {
        _header.classMode = false;
        _header.classCustomDesignMode = null;
        _header.textColor = null;
        _header.btnBorderColor = null;
        _header.btnTextColor = null;
        _header.classSideMenuMode = null;

        $( '.navbar-toggle' ).on( 'click', f => {

            _header.classList = _header.attr( 'class' ).split( /\s+/ );
            _header.noBold = null;
            for ( let i = 0; i < _header.classList.length; i++ ) {
                if ( header_type_two === false ) {
                    if ( _header.classList[i] === 'navbar-text-custom-color' ) {
                        _header.textCustomColor = 'navbar-text-custom-color';
                        _header.btnBorderColor = 'b-transparent-white-navbar-text-custom-color';
                        _header.btnTextColor = '';
                    }
                }
                if ( _header.attr( 'data-pages-resize-class' ) ) {
                    if ( _header.attr( 'data-pages-resize-class' ).match( 'navbar-custom-color' ) != null ) {
                        _header.classMode = true;
                        _header.classCustomDesignMode = 'navbar-custom-color';
                    } else if ( _header.attr( 'data-pages-resize-class' ).match( 'navbar-design-color' ) != null ) {
                        _header.classMode = true;
                        _header.classCustomDesignMode = 'navbar-design-color';
                    }
                    if ( _header.attr( 'data-pages-resize-class' ).match( 'navbar-dark' ) != null ) {
                        _header.classMode = true;
                        _header.textColor = 'text-white';
                        _header.btnBorderColor = 'b-transparent-white';
                        _header.btnTextColor = 'text-white';
                        _header.classSideMenuMode = 'bg-black';
                    } else if ( _header.attr( 'data-pages-resize-class' ).match( 'navbar-light' ) != null ) {
                        _header.classMode = true;
                        _header.textColor = 'text-black';
                        _header.btnBorderColor = 'b-transparent-black';
                        _header.btnTextColor = 'text-black';
                    }
                } else {
                    // console.log(header_type_two);
                    if ( header_type_two === false ) {
                        if ( _header.classList[i] === "navbar-custom-color" ) {
                            _header.classMode = true;
                            _header.classCustomDesignMode = 'navbar-custom-color';
                            // console.log(_header.classCustomDesignMode);
                        } else if ( _header.classList[i] === "navbar-design-color" ) {
                            _header.classMode = true;
                            _header.classCustomDesignMode = 'navbar-design-color';
                        }
                    }
                    if ( _header.classList[i] === "navbar-dark" ) {
                        _header.classMode = true;
                        _header.textColor = 'text-white';
                        _header.btnBorderColor = 'b-transparent-white';
                        _header.btnTextColor = 'text-white';
                        _header.classSideMenuMode = 'bg-black';
                    } else if ( _header.classList[i] === "navbar-light" ) {
                        _header.classMode = true;
                        _header.textColor = 'text-black';
                        _header.btnBorderColor = 'b-transparent-black';
                        _header.btnTextColor = 'text-black';
                        _header.classSideMenuMode = 'bg-white';
                    }
                }
                if ( _header.classList[i] === "no-bold" ) {
                    _header.noBold = 'no-bold';
                }
            }

            if ( _header.classMode ) {

                if ( _header_menu_right.find( 'li a' ).hasClass( 'text-master' ) ) {
                    _header_menu_right.find( 'li a' ).removeClass( 'text-master' );
                }
                if ( _header_menu_right.find( '[data-bs-dismiss] > svg' ).hasClass( 'text-black' ) ) {
                    _header_menu_right.find( '[data-bs-dismiss] > svg' ).removeClass( 'text-black' );
                }
                if ( _header.classCustomDesignMode != null ) {
                    _header.classSideMenuMode = _header.classCustomDesignMode;
                }
                if ( _header.textCustomColor != null ) {
                    _header.textColor = _header.textCustomColor;
                }
                if ( _header.noBold != null ) {
                    _header.classSideMenuMode += ' ' + _header.noBold;
                }
                // console.log('------------------------------------------------------------------------------------');
                _header_menu_right.find( '[data-bs-dismiss] > svg' ).addClass( _header.textColor );
                _header_menu_right.find( 'li ul li svg' ).addClass( _header.textColor );
                _header_menu_right.find( 'li a' ).addClass( _header.textColor );
                _header_menu_right.find( 'li a.btn' ).addClass( _header.btnBorderColor );
                _header_menu_right.find( 'li a.btn' ).addClass( _header.btnTextColor );

                _header_menu_right.find( 'ul.dropdown-menu' ).addClass( _header.classSideMenuMode );
                _header_menu_right.find( '.modal-content' ).addClass( _header.classSideMenuMode );
                _header_menu_right.find( '.modal-body' ).addClass( _header.classSideMenuMode );
            }
        });
    };

    $.fn.headerOverflowCheck = ( _header ) => {
        var windowMasterWidth = $(window).width();

        const navbarBrandOuterWidth = _header.find( '.navbar-brand' ).outerWidth();
        let navbarToggleCollapseOuterWidth = _header.find( '.navbar-toggle-collapse' ).outerWidth();
        let navbarOuterWidth = navbarBrandOuterWidth + navbarToggleCollapseOuterWidth;
        let containerOuterWidth = _header.find( '[class*=container]' ).outerWidth();

        // console.log("forDebug", "containerOuterWidth", containerOuterWidth);
        // console.log("forDebug", "navbarOuterWidth", navbarOuterWidth);

        if ( containerOuterWidth < navbarOuterWidth ) {
            _header.find( '.navbar-toggle-collapse' ).addClass( 'hidden' );
            _header.find( '.navbar-toggle' ).addClass( 'visible' );
            _header.find( '.minimized-partials' ).removeClass( 'hidden' );
        } else {
            if ( $( window ).width() >= 768 ) {
                _header.find( '.navbar-toggle-collapse' ).removeClass( 'hidden' );
                _header.find( '.navbar-toggle-collapse' ).removeClass( 'invisible' );
                _header.find( '.navbar-toggle' ).removeClass( 'visible' );
                _header.find( '.minimized-partials' ).addClass( 'hidden' );
            }
        }
        $( window ).on( 'resize', function () {
            if ( $(window).width() == windowMasterWidth ) {
                return;
            }
            windowMasterWidth = $(window).width();

            if ( navbarToggleCollapseOuterWidth === 0 ) {
                if ( !_header.find( '.navbar-toggle-collapse' ).hasClass( 'invisible' ) ) {
                    // _header.find( '.navbar-toggle-collapse' ).addClass( 'invisible' );
                }
                navbarToggleCollapseOuterWidth = _header.find( '.navbar-toggle-collapse' ).outerWidth();
                navbarOuterWidth = navbarBrandOuterWidth + navbarToggleCollapseOuterWidth;
            }
            containerOuterWidth = _header.find( '[class*=container]' ).outerWidth();
            if ( containerOuterWidth < navbarOuterWidth ) {
                _header.find( '.navbar-toggle-collapse' ).addClass( 'hidden' );
                _header.find( '.navbar-toggle' ).addClass( 'visible' );
                _header.find( '.minimized-partials' ).removeClass( 'hidden' );
            } else {
                if ( $( window ).width() >= 768 ) {
                    _header.find( '.navbar-toggle-collapse' ).removeClass( 'hidden' );
                    _header.find( '.navbar-toggle-collapse' ).removeClass( 'invisible' );
                    _header.find( '.navbar-toggle' ).removeClass( 'visible' );
                    _header.find( '.minimized-partials' ).addClass( 'hidden' );
                }
            }
        });
    };
    $.fn.headerDoubleOverflowCheck = ( _header_one, _header_two ) => {
        var windowMasterWidth = $(window).width();

        const navbar = _header_two.find( 'div[class*=container] ul.navbar-nav' );
        let navbarLeftOuterWidth = _header_two.find( 'div[class*=container] ul.navbar-nav' )[0].offsetWidth;
        let navbarRightOuterWidth = _header_two.find( 'div[class*=container] ul.navbar-nav' )[1].offsetWidth;
        let navbarOuterWidth = navbarLeftOuterWidth + navbarRightOuterWidth;
        let containerOuterWidth = _header_two.find( 'div[class*=container]' ).outerWidth();

        if ( $( window ).innerWidth() < navbarOuterWidth || containerOuterWidth < navbarOuterWidth ) {
            _header_one.addClass( 'position-fixed top-0' );
            _header_two.addClass( 'hidden' );
            _header_one.find( 'ul.nav.inner.navbar-nav' ).addClass( 'hidden' );
            _header_one.find( '.navbar-toggle' ).addClass( 'visible' );
        } else {
            if ( $( window ).width() >= 768 ) {
                _header_one.removeClass( 'position-fixed top-0' );
                _header_two.removeClass( 'hidden' );
                _header_two.removeClass( 'invisible h-0 padding-0' );
                _header_one.find( 'ul.nav.inner.navbar-nav' ).removeClass( 'hidden' );
                _header_one.find( '.navbar-toggle' ).removeClass( 'visible' );
            } else {
                _header_one.addClass( 'position-fixed top-0' );
            }
        }
        $( window ).on( 'resize', function () {
            if ( $(window).width() == windowMasterWidth ) {
                return;
            }
            windowMasterWidth = $(window).width();

            if ( navbarLeftOuterWidth === 0 && navbarRightOuterWidth === 0 ) {
                if ( !_header_two.hasClass( 'invisible' ) ) {
                    _header_two.addClass( 'invisible h-0 padding-0' );
                }
                navbarLeftOuterWidth = _header_two.find( '[class*=container] ul.navbar-nav' )[0].offsetWidth;
                navbarRightOuterWidth = _header_two.find( '[class*=container] ul.navbar-nav' )[1].offsetWidth;
                navbarOuterWidth = navbarLeftOuterWidth + navbarRightOuterWidth;
            }
            containerOuterWidth = _header_two.find( 'div[class*=container]' ).outerWidth();
            if ( this.innerWidth < navbarOuterWidth || containerOuterWidth < navbarOuterWidth ) {
                _header_one.addClass( 'position-fixed top-0' );
                _header_two.addClass( 'hidden' );
                _header_one.find( 'ul.nav.inner.navbar-nav' ).addClass( 'hidden' );
                _header_one.find( '.navbar-toggle' ).addClass( 'visible' );
            } else {
                if ( $( window ).width() >= 768 ) {
                    _header_one.removeClass( 'position-fixed top-0' );
                    _header_two.removeClass( 'hidden' );
                    _header_two.removeClass( 'invisible h-0 padding-0' );
                    _header_one.find( 'ul.nav.inner.navbar-nav' ).removeClass( 'hidden' );
                    _header_one.find( '.navbar-toggle' ).removeClass( 'visible' );
                }
            }
        });
    };

    $.fn.headerDoubleSticky = ( _header ) => {
        $( window ).on( 'scroll', f => {
            const scroll = $( window ).scrollTop();
            if ( scroll >= _header.find( '.header-one' ).outerHeight() ) {
                _header.find( '.header-two' ).addClass( 'fixed-top' );
            } else {
                _header.find( '.header-two' ).removeClass( 'fixed-top' );
            }
        });
    };

    $.fn.headerCenteredOverflowCheck = ( _header ) => {
        var windowMasterWidth = $(window).width();

        let sumLeftOuterWidth = 0;
        let sumRightOuterWidth = 0;
        const navbarLeftElements = _header.find( '[data-builder-left-nav] > *' );
        const navbarRightElements = _header.find( '[data-builder-right-nav] > *' );
        let navbarLeftOuterWidth = _header.find( '[data-builder-left-nav]' ).outerWidth( true );
        let navbarRightOuterWidth = _header.find( '[data-builder-right-nav]' ).outerWidth( true );

        for ( let i=0; i<navbarLeftElements.length; i++ ) {
            sumLeftOuterWidth += $( navbarLeftElements[i]).outerWidth( true );
        }
        for ( let i=0; i<navbarRightElements.length; i++ ) {
            sumRightOuterWidth += $( navbarRightElements[i]).outerWidth( true );
        }

        if ( sumLeftOuterWidth > navbarLeftOuterWidth || sumRightOuterWidth > navbarRightOuterWidth ) {
            _header.find( '[data-builder-left-nav]' ).addClass( 'invisible h-0' );
            _header.find( '[data-builder-right-nav]' ).addClass( 'invisible h-0' );
            _header.find( '[data-builder-center-logo]' ).addClass( 'w-100' );
            _header.find( '.navbar-toggle' ).addClass( 'visible' );
            if ( !_header.find( '.navbar-toggle' ).hasClass( 'me-auto' ) ) {
                _header.find( '.navbar-toggle' ).addClass( 'me-auto' );
            }
            if ( !_header.find( '.navbar-brand' ).hasClass( 'me-auto' ) ) {
                _header.find( '.navbar-brand' ).addClass( 'me-auto' );
            }
        } else {
            if ( $( window ).width() >= 768 ) {
                _header.find( '[data-builder-left-nav]' ).removeClass( 'invisible h-0' );
                _header.find( '[data-builder-right-nav]' ).removeClass( 'invisible h-0' );
                _header.find( '[data-builder-center-logo]' ).removeClass( 'w-100' );
                _header.find( '.navbar-toggle' ).removeClass( 'visible' );
                _header.find( '.navbar-toggle' ).addClass( 'hidden' );
                _header.find( '.navbar-brand' ).removeClass( 'me-auto' );
            }
        }
        $( window ).on( 'resize', function () {
            if ( $(window).width() == windowMasterWidth ) {
                return;
            }
            windowMasterWidth = $(window).width();

            navbarLeftOuterWidth = _header.find( '[data-builder-left-nav]' ).outerWidth( true );
            navbarRightOuterWidth = _header.find( '[data-builder-right-nav]' ).outerWidth( true )
            if ( ( navbarLeftOuterWidth >= 330 && navbarLeftOuterWidth <= 475 ) || ( navbarRightOuterWidth >= 330 && navbarRightOuterWidth <= 475 ) ) {
                sumLeftOuterWidth = 0;
                sumRightOuterWidth = 0;
                navbarLeftOuterWidth = _header.find( '[data-builder-left-nav]' ).outerWidth( true );
                navbarRightOuterWidth = _header.find( '[data-builder-right-nav]' ).outerWidth( true );

                for ( let i=0; i<navbarLeftElements.length; i++ ) {
                    sumLeftOuterWidth += $( navbarLeftElements[i]).outerWidth( true );
                }
                for ( let i=0; i<navbarRightElements.length; i++ ) {
                    sumRightOuterWidth += $( navbarRightElements[i]).outerWidth( true );
                }
            }

            if ( sumLeftOuterWidth > navbarLeftOuterWidth || sumRightOuterWidth > navbarRightOuterWidth ) {
                _header.find( '[data-builder-left-nav]' ).addClass( 'invisible h-0' );
                _header.find( '[data-builder-right-nav]' ).addClass( 'invisible h-0' );
                _header.find( '[data-builder-center-logo]' ).addClass( 'w-100' );
                _header.find( '.navbar-toggle' ).addClass( 'visible' );
                if ( !_header.find( '.navbar-toggle' ).hasClass( 'me-auto' ) ) {
                    _header.find( '.navbar-toggle' ).addClass( 'me-auto' );
                }
                if ( !_header.find( '.navbar-brand' ).hasClass( 'me-auto' ) ) {
                    _header.find( '.navbar-brand' ).addClass( 'me-auto' );
                }
            } else {
                if ( $( window ).width() >= 768 ) {
                    _header.find( '[data-builder-left-nav]' ).removeClass( 'invisible h-0' );
                    _header.find( '[data-builder-right-nav]' ).removeClass( 'invisible h-0' );
                    _header.find( '[data-builder-center-logo]' ).removeClass( 'w-100' );
                    _header.find( '.navbar-toggle' ).removeClass( 'visible' );
                    _header.find( '.navbar-toggle' ).addClass( 'hidden' );
                    _header.find( '.navbar-brand' ).removeClass( 'me-auto' );
                }
            }
        });
    }

    $.fn.toArray = ( arrayLike ) => {
        return [].slice.call( arrayLike );
    }

})( jQuery );
